import React, { useEffect } from "react";

import Hero from "./hero/Hero";
import About from "./about/About";
import ClassesSlider from '../../components/slider/classes_slider';
import Programs from "./programs/Programs";
import Coaches from "./coaches/Coaches";
import Schedule from "./schedule/Schedule";
import ContactMap from "./contact-map/ContactMap";
import InstagramSection from "./instagram/InstagramSection";
import SectionDivider from "../../components/decor/SectionDivider";
import Marquee from "../../components/decor/Marquee";
import Ribbon from "../../components/decor/Ribbon";
// import FooterSection from "./footer-section/FooterSection";

export default function Main() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <main>
      <Hero />
      <Marquee items={["Muay Thai", "K-1", "MMA", "Boxing", "Strength & Mobility"]} />
      {/* <About /> */}
      <ClassesSlider  />
      <SectionDivider label="Mūsu programmas" />
      <Programs />
      <SectionDivider label="Treneri" subtle />
      <Coaches />
      <SectionDivider label="Grafiks" subtle />
      <Schedule />
      <ContactMap />
      <SectionDivider label="Instagram" subtle />
      <InstagramSection />
      {/* <FooterSection /> */}
    </main>
  );
}
